import { HStack, Icon, Link as ChakraLink, Stack, Text } from '@chakra-ui/react'
import sortBy from 'lodash/sortBy'
import { memo } from 'react'
import { useShallow } from 'zustand/shallow'

import useGetObjects from '@app/hooks/useGetObjects'
import NavButton from '@app/shared/layout/shells/components/navButton'
import { useStore } from '@app/store'
import ICON_MAP from '@app/utils/iconMap'
import { showRouteByTypeAndId } from '@app/utils/routeHelpers'

const ROUTE_MAP = {
  Metric: 'metrics',
  Strategy: 'strategy'
}

const FavoritesSidebarList = () => {
  const defaultFavorites = useGetObjects('favorite')

  const favorites = useStore(
    useShallow((state) =>
      defaultFavorites
        .map((favorite) => {
          const favoritable = state[favorite.favoritable.classType]?.[favorite.favoritableId]

          return {
            ...favorite,
            favoritable
          }
        })
        .filter((f) => !!f.favoritable)
    )
  )

  if (!favorites || !favorites.length) {
    return (
      <Stack key="favorites-list">
        <HStack gap={3} mb={2} px={3}>
          <Icon color="yellow.500">
            <ICON_MAP.Favorited />
          </Icon>
          <Text fontSize="sm" fontWeight="500">
            Favorites
          </Text>
        </HStack>
        <Text fontSize="sm" color="fg.muted" py={2} px={3}>
          Star a map to add it to your favorites.
        </Text>
      </Stack>
    )
  }

  return (
    <Stack key="favorites-list">
      <HStack gap={3} mb={2} px={3}>
        <Icon color="yellow.500">
          <ICON_MAP.Favorited />
        </Icon>
        <Text fontSize="sm" fontWeight="500">
          Favorites
        </Text>
      </HStack>
      {sortBy(favorites, ['favoritableType', 'favoritable.name']).map((favorite) => (
        <NavButton
          as={ChakraLink}
          size="sm"
          key={favorite.id}
          icon={ICON_MAP[favorite.favoritableType]}
          label={favorite.favoritable.name}
          href={showRouteByTypeAndId(`${ROUTE_MAP[favorite.favoritableType]}`, favorite.favoritableId)}
        />
      ))}
    </Stack>
  )
}

export default memo(FavoritesSidebarList)
